import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Badge from "react-bootstrap/Badge";
import { Row, Col } from "react-bootstrap";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { FaInfoCircle } from "react-icons/fa";

function ProjectCards(props) {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <>
      <Card className="project-card-view" onClick={handleShow} style={{ cursor: "pointer" }}>
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        <Card.Body className="d-flex flex-column justify-content-between" style={{ padding: "20px" }}>
          <div>
            <Card.Title className="purple font-weight-bold" style={{ textAlign: "left", marginBottom: "12px" }}>
              {props.title}
            </Card.Title>
            <Card.Text style={{ textAlign: "justify", fontSize: "0.95em", color: "#ccc" }}>
              {props.description.length > 140
                ? props.description.substring(0, 137) + "..."
                : props.description}
            </Card.Text>
          </div>
          <div className="mt-3">
            <Button
              variant="primary"
              onClick={(e) => {
                e.stopPropagation();
                handleShow();
              }}
              className="w-100"
            >
              <FaInfoCircle /> &nbsp; View Details
            </Button>
          </div>
        </Card.Body>
      </Card>

      {/* Modern Glassmorphic Detail Modal */}
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        size="lg"
        dialogClassName="project-detail-modal-dialog"
        contentClassName="project-detail-modal"
      >
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title className="purple">{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <Row>
            <Col md={5} className="d-flex align-items-center mb-3 mb-md-0">
              <img
                src={props.imgPath}
                alt={props.title}
                className="img-fluid rounded shadow-sm modal-project-img"
                style={{ maxHeight: "250px", objectFit: "cover", width: "100%" }}
              />
            </Col>
            <Col md={7}>
              <h5 className="mb-2 text-light" style={{ textAlign: "left" }}>About the Project</h5>
              <p style={{ textAlign: "justify", color: "#e0d5ec" }}>{props.description}</p>

              {props.tags && props.tags.length > 0 && (
                <div className="mb-3" style={{ textAlign: "left" }}>
                  <h6 className="text-light mb-2">Technologies Used:</h6>
                  <div className="d-flex flex-wrap gap-2">
                    {props.tags.map((tag, idx) => (
                      <Badge bg="secondary" className="tech-badge" key={idx}>
                        {tag}
                      </Badge>
                    ))}
                  </div>
                </div>
              )}
            </Col>
          </Row>

          {props.features && props.features.length > 0 && (
            <div className="mt-4" style={{ textAlign: "left" }}>
              <h5 className="text-light border-bottom-custom pb-2">Key Features & Learnings</h5>
              <ul className="project-features-list">
                {props.features.map((feature, idx) => (
                  <li key={idx} style={{ color: "#e0d5ec", marginBottom: "8px" }}>{feature}</li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" href={props.ghLink} target="_blank" className="d-flex align-items-center">
            <BsGithub /> &nbsp; GitHub
          </Button>
          {!props.isBlog && props.demoLink && (
            <Button variant="primary" href={props.demoLink} target="_blank" className="d-flex align-items-center">
              <CgWebsite /> &nbsp; Demo
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProjectCards;
